import { Box } from "@mui/material";
import { useContext } from "react";

import { ShowSettingsComponent } from "./component";
import { VersionedDataContext } from "../../../../contexts/versioned_data/context";
import { useApi } from "../../../../contexts/app/provider";
import { SysMessageLevel } from "../../../../contexts/sys_messages/type";
import { useGetAllMyEngineSettingsQuery } from "../../../../services/api/__generated__/backend_gateway-types";
import { SysMessagesContext } from "../../../../contexts/sys_messages/context";

export const ShowSettings = ({ isLoading }: { isLoading: boolean }) => {
  const { addSystemMessage } = useContext(SysMessagesContext);
  const { apiService } = useApi();
  const { mainRun, lastSuccessfulRun, comparedRun } =
    useContext(VersionedDataContext);

  const { data: engineSettingsData } = useGetAllMyEngineSettingsQuery({
    client: apiService.getClient(),
    onError: (error) => {
      addSystemMessage({
        level: SysMessageLevel.WARNING,
        message: error.message!,
      });
    },
  });

  const engineSettingsList = engineSettingsData?.getAllMyEngineSettings || [];

  const currentRun = mainRun || lastSuccessfulRun;

  const { settingsNameAndVersion: mainSettingsNameAndVersion } =
    currentRun?.runSettings || {};
  const mainEngineSettings = mainSettingsNameAndVersion
    ? engineSettingsList.find(
        (s) => s.name === (mainSettingsNameAndVersion.split("|")[0] as String)
      ) || null
    : null;

  const isComparisonRunView = !!comparedRun;
  const mainSettingsName = mainSettingsNameAndVersion?.split("|")[0] || "";
  const mainSettingsVersion = mainSettingsNameAndVersion?.split("|")[1] || "";

  let cmpSettingsName = null;
  let cmpSettingsVersion = null;
  let cmpEngineSettings = null;

  if (isComparisonRunView) {
    const { settingsNameAndVersion: cmpSettingsNameAndVersion } =
      comparedRun?.runSettings || {};
    cmpSettingsName = cmpSettingsNameAndVersion?.split("|")[0] || "";
    cmpSettingsVersion = cmpSettingsNameAndVersion?.split("|")[1] || "";
    cmpEngineSettings = cmpSettingsNameAndVersion
      ? engineSettingsList.find(
          (s) => s.name === (cmpSettingsNameAndVersion.split("|")[0] as String)
        ) || null
      : null;
  }

  return (
    <Box>
      <ShowSettingsComponent
        isLoading={isLoading}
        settingsName={mainSettingsName}
        settingsVersion={mainSettingsVersion}
        currentEngineSettings={
          mainEngineSettings?.json ? JSON.parse(mainEngineSettings.json) : null
        }
        isComparing={isComparisonRunView}
        comparedSettingsName={cmpSettingsName}
        comparedSettingsVersion={cmpSettingsVersion}
        comparedEngineSettings={
          cmpEngineSettings?.json ? JSON.parse(cmpEngineSettings.json) : null
        }
      />
    </Box>
  );
};
